<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <!-- <p><b>Kalaignar100 Winner List</b></p> -->

        <!-- Small boxes (Stat box) -->
        <div class="card-header " style="background-color: white !important;">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">DASHBOARD</h4>

            </div>
        </div>
        <!-- Small boxes (Stat box) -->
        <div class="row">
            <div class="col-lg-12 col-12">
                <!-- small box -->
                <div class="small-box bg-info">
                    <div class="inner">
                        <h3>{{courses_assigned_to.length}}</h3>

                        <p>No. of Course(s) Assigned </p>
                    </div>
                    <div class="icon">
                        <i class="ion "></i>
                    </div>
                    <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
                </div>
            </div>
            

        </div>
            
<!-- <div class="container card-body ">
    <div class="row" *ngIf="courses_assigned_to.length > 0">
        <div class="col-md-12">
        <div style="display:flex;flex-wrap: wrap;">
            <h3>Course Assigned</h3>
            <a [routerLink]="['courseAssignedMentor']" class="btn btn-primary btn-sm"
                style="position:absolute;right: 20px;padding:10px;">View More</a>
        </div>


            <div class="row">
                <div class="col-md-4" *ngFor="let item of courses_assigned_to">
                    <div class="card">
                        <img class="card-img-top"
                            src="https://redmindtechnologies.com/dmk_php-dhanasekar/images/course.jpg" alt="Card image">
                        <div class="card-body">
                            <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}</h4>
                            <div class="card-text" style="font-size: 12px;">{{item.course_description}}</div>
                            <span class="card-text" style="float:left">Start Date:
                                {{item.start_date | date:'d-M-Y'}}</span>
                            <div class="card-text" style="font-size: 14px;">Duration: {{item.hours}} Hours</div>
                            <button class="btn btn-primary" style="float: right;" data-toggle="modal"
                                data-target="#showCM" (click)="buttonviewmeeting(item,'show')"
                                style="float: right;margin-right: 20px;">Show</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>


<div class="modal fade" id="showCM">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="card-success">
                <div class="card-header">
                    <h3 class="card-title">COURSES ASSIGNED </h3>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="card-body">
                    <form class="register-form" [formGroup]='editmeetingform'
                        autocomplete="off">
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Course Name </label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course Name "
                                    [value]="CM_course_name" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>District</label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter District "
                                    [value]="CM_district" readonly="readonly">

                            </div>

                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Constituency</label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Constituency"
                                    [value]="CM_constituency" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Organizer</label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Organizer"
                                    [value]="CM_organizer" readonly="readonly">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Start Date</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course Start Date"
                                    [value]="CM_startDate" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course End Date</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course End Date"
                                    [value]="CM_endDate" readonly="readonly">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Start Time</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course Start Time"
                                    [value]="CM_startTime" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course End Time</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course End Time"
                                    [value]="CM_endTime" readonly="readonly">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Primary Volunteer</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Primary Volunteer"
                                    [value]="CM_volunteer1" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Secondary Volunteer</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control"
                                    placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2" readonly="readonly">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Location</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course Location"
                                    [value]="CM_location" readonly="readonly">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Link</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Status"
                                    [value]="CM_session_link" readonly="readonly">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="!editfield">
                            <div class="col-md-12">
                                <label>Comments</label>
                                <textarea class="form-control" formControlName="comments" readonly
                                    [value]="CM_comments"></textarea>
                            </div>
                        </div>

                        <div class="form-group row" *ngIf="editfield">
                           
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>District</label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control"
                                    placeholder="Enter District / மாவட்டம்" [value]="CM_district" readonly="readonly">

                            </div>

                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Constituency</label><span class="required "> *</span>
                                <input pInputText type="text" class="form-control"
                                    placeholder="Enter Constituency/ வாக்காளர் தொகுதி" [value]="CM_constituency"
                                    readonly="readonly">

                            </div>
                       
                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Start Date</label><span class="required">*</span>
                                <input pInputText type="date" class="form-control" placeholder="Enter Course Start Date"
                                    [value]="CM_startDate">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course End Date</label><span class="required">*</span>
                                <input pInputText type="date" class="form-control" placeholder="Enter Course End Date"
                                    [value]="CM_endDate">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Start Time</label><span class="required">*</span>
                                <input pInputText type="time" class="form-control" placeholder="Enter Course Start Time"
                                    [value]="CM_startTime">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course End Time</label><span class="required">*</span>
                                <input pInputText type="time" class="form-control" placeholder="Enter Course End Time"
                                    [value]="CM_endTime">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Primary Volunteer</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Primary Volunteer"
                                    [value]="CM_volunteer1">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Secondary Volunteer</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control"
                                    placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2">

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Course Location</label><span class="required">*</span>
                                <input pInputText type="text" class="form-control" placeholder="Enter Course Location"
                                    [value]="CM_location">

                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label class="form-label">Status</label><span class="required">*</span>
                                <select name="status" class="form-control" formControlName="status"
                                    [(ngModel)]="CM_status">
                                    <option value="">Select any status </option>
                                    <option>Open</option>
                                    <option>Session Start</option>
                                    <option>Session End</option>
                                    <option>Inprogress</option>
                                    <option>Cancelled</option>
                                    <option>Postponed</option>
                                </select>

                            </div>
                        </div>
                        <div class="form-group row" *ngIf="editfield">
                            <div class="col-md-12">
                                <label>Comments</label>
                                <textarea class="form-control" formControlName="comments"
                                    [value]="CM_comments"></textarea>
                            </div>
                        </div>

                        <div *ngIf="editfield" class="d-flex justify-content-center">
                            <div style="width:200px">
                                <button class="btn btn-success btn btn-block">Update District Occurance</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div> -->

       

    </div>
</section>
<!-- <app-course-assigned></app-course-assigned> -->
<!-- /.content -->